import { useQuery } from "@tanstack/react-query";

import { getReportingGenerations } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { REPORTING_QUERY_KEYS } from "./queryKeys";

export function useReportingGenerationsQuery() {
  return useQuery({
    queryKey: REPORTING_QUERY_KEYS.generations(),
    queryFn: processResponse(() => getReportingGenerations()),
    staleTime: 5 * 60 * 1000,
  });
}
